
export const cognitive = {
  intro: {
    title: 'Avaliação Cognitiva',
    subtitle: 'Meça sua capacidade cognitiva através de raciocínio verbal, numérico e abstrato.',
    duration: '{{timeLimit}} minutos · 50 perguntas',
    areas: 'Raciocínio verbal, numérico e abstrato',
    beforeYouBegin: 'Antes de começar',
    instruction1: 'Encontre um ambiente tranquilo sem distrações',
    instruction2: 'Certifique-se de ter {{timeLimit}} minutos ininterruptos',
    instruction3: 'O cronômetro não pode ser pausado após iniciado',
    instruction4: 'Trabalhe rapidamente mas com precisão — sem penalidade por respostas erradas',
    startAssessment: 'Iniciar Avaliação',
    backToHome: 'Voltar para a página inicial',
    aiWarningTitle: 'Aviso de Integridade Acadêmica',
    aiWarningText: 'O uso de ferramentas de IA, assistência externa ou quaisquer recursos não autorizados é estritamente proibido. Nosso sistema monitora ativamente padrões irregulares. Candidatos que utilizarem IA ou ajuda externa serão imediatamente desqualificados.'
  },
  loading: {
    title: 'Carregando Avaliação...',
    message: 'Por favor, aguarde enquanto preparamos sua avaliação cognitiva.'
  },
  error: {
    title: 'Erro na Avaliação',
    message: 'Houve um problema ao carregar as perguntas. Tente novamente.',
    retry: 'Tentar Avaliação Novamente',
    indexTitle: 'Erro no Índice da Pergunta',
    indexMessage: 'A pergunta está fora do intervalo. Reinicie a avaliação.',
    questionTitle: 'Erro na Pergunta',
    questionMessage: 'Houve um problema com esta pergunta. Tente novamente.',
    restart: 'Reiniciar Avaliação'
  },
  test: {
    questionCounter: 'Pergunta',
    of: 'de',
    reasoning: 'Raciocínio'
  },
  types: {
    verbal: 'Verbal',
    numerical: 'Numérico',
    abstract: 'Abstrato'
  },
  results: {
    title: 'Seus Resultados da Avaliação Cognitiva',
    subtitle: 'Análise abrangente de suas habilidades cognitivas',
    yourStrengths: 'Suas Forças Cognitivas',
    strongestArea: 'Sua área cognitiva mais forte',
    percentile: 'º percentil',
    performance: 'Resumo de Performance',
    questionsCompleted: 'Perguntas Completadas',
    correctResponses: 'Respostas Corretas',
    successRate: 'Taxa de Sucesso',
    timeManagement: 'Gestão de Tempo',
    remaining: 'restante',
    growthOpportunities: 'Oportunidades de Crescimento',
    understanding: 'Entendendo Seus Resultados',
    profileDesc: 'Seu perfil cognitivo mostra como você processa diferentes tipos de informação e resolve problemas em três áreas principais.',
    verbalReasoning: 'Raciocínio Verbal',
    verbalDesc: 'Sua capacidade de entender, analisar e trabalhar com informações escritas e conceitos de linguagem.',
    numericalReasoning: 'Raciocínio Numérico',
    numericalDesc: 'Sua capacidade de trabalhar com números, conceitos matemáticos e relacionamentos quantitativos.',
    abstractReasoning: 'Raciocínio Abstrato',
    abstractDesc: 'Sua habilidade em identificar padrões, relacionamentos lógicos e resolver problemas novos.',
    reminder: 'Lembre-se: As habilidades cognitivas podem ser desenvolvidas através da prática e aprendizado.',
    practiceTip: 'Pratique Regularmente',
    practiceDesc: 'Exercícios mentais regulares e quebra-cabeças desafiadores podem ajudar a melhorar a performance cognitiva.',
    learningPath: 'Aprendizado Focado',
    learningDesc: 'Direcione suas áreas mais fracas com programas de treinamento específicos e recursos educacionais.',
    nextSteps: 'Próximos Passos',
    nextStepsDesc: 'Considere refazer a avaliação após prática focada para acompanhar sua melhoria.'
  },
  performance: {
    outstanding: 'Performance Excepcional',
    strong: 'Performance Forte',
    good: 'Boa Performance',
    developing: 'Performance em Desenvolvimento',
    growing: 'Performance em Crescimento',
    learning: 'Performance de Aprendizado'
  },
  message: {
    outstanding: 'Habilidades cognitivas excepcionais! Você demonstra habilidades de raciocínio superiores em múltiplos domínios.',
    strong: 'Performance cognitiva forte! Você mostra habilidades de raciocínio bem desenvolvidas com espaço para crescimento contínuo.',
    good: 'Habilidades cognitivas sólidas! Você demonstra boas habilidades de raciocínio com potencial para desenvolvimento adicional.',
    developing: 'Suas habilidades cognitivas estão se desenvolvendo bem. Com prática focada, você pode fortalecer suas habilidades de raciocínio.',
    growing: 'Você mostra promessa no raciocínio cognitivo. Aprendizado e prática contínuos ajudarão você a melhorar.',
    learning: 'Toda avaliação é uma oportunidade de aprendizado. Foque em desenvolver suas habilidades cognitivas passo a passo.'
  },
  thankYou: {
    title: 'Avaliação Concluída!',
    message: 'Obrigado por completar a avaliação.',
    backToHome: 'Voltar ao Início'
  },
  questions: {
    verbal: {
      q1: {
        question: 'Qual palavra melhor completa esta analogia: LIVRO está para ler assim como CANÇÃO está para ____',
        optionA: 'Escrever',
        optionB: 'Ouvir',
        optionC: 'Dançar',
        optionD: 'Cantar'
      },
      q2: {
        question: 'Qual é o antônimo de "MUNDANO"?',
        optionA: 'Comum',
        optionB: 'Empolgante',
        optionC: 'Diário',
        optionD: 'Simples'
      },
      q3: {
        question: 'Qual palavra NÃO pertence ao grupo?',
        optionA: 'Eufórico',
        optionB: 'Jubiloso',
        optionC: 'Extasiado',
        optionD: 'Melancólico'
      },
      q4: {
        question: '"ARTICULADO" está para falar assim como "GRACIOSO" está para ____',
        optionA: 'Pensar',
        optionB: 'Mover-se',
        optionC: 'Escrever',
        optionD: 'Cantar'
      },
      q5: {
        question: 'Qual palavra é mais próxima em significado de "PLAUSÍVEL"?',
        optionA: 'Impossível',
        optionB: 'Acreditável',
        optionC: 'Estranho',
        optionD: 'Certo'
      },
      q6: {
        question: 'Qual palavra melhor descreve alguém que é "PRAGMÁTICO"?',
        optionA: 'Idealista',
        optionB: 'Prático',
        optionC: 'Emocional',
        optionD: 'Artístico'
      },
      q7: {
        question: 'Qual é o significado de "EFÊMERO"?',
        optionA: 'Permanente',
        optionB: 'De curta duração',
        optionC: 'Grande',
        optionD: 'Bonito'
      },
      q8: {
        question: 'Qual palavra é mais semelhante a "TENAZ"?',
        optionA: 'Fraco',
        optionB: 'Persistente',
        optionC: 'Rápido',
        optionD: 'Gentil'
      },
      q9: {
        question: 'O que significa "CÂNDIDO"?',
        optionA: 'Doce',
        optionB: 'Escondido',
        optionC: 'Honesto',
        optionD: 'Irritado'
      },
      q10: {
        question: '"SOFISTICADO" está para simples assim como "COMPLEXO" está para ____',
        optionA: 'Difícil',
        optionB: 'Fácil',
        optionC: 'Básico',
        optionD: 'Avançado'
      },
      q11: {
        question: 'Qual é o melhor sinônimo para "UBÍQUO"?',
        optionA: 'Raro',
        optionB: 'Em todo lugar',
        optionC: 'Escondido',
        optionD: 'Novo'
      },
      q12: {
        question: 'Qual é o sinônimo mais preciso para "PERSPICAZ"?',
        optionA: 'Confuso',
        optionB: 'Sagaz',
        optionC: 'Barulhento',
        optionD: 'Misterioso'
      },
      q13: {
        question: 'Qual palavra melhor completa: "INDÍGENA" está para nativo assim como "EXTRÂNEO" está para ____',
        optionA: 'Essencial',
        optionB: 'Irrelevante',
        optionC: 'Interno',
        optionD: 'Óbvio'
      },
      q14: {
        question: 'Em um argumento lógico, se todas as rosas são flores e todas as flores precisam de água, o que podemos concluir sobre as rosas?',
        optionA: 'São bonitas',
        optionB: 'Precisam de água',
        optionC: 'São vermelhas',
        optionD: 'Têm espinhos'
      },
      q15: {
        question: 'Qual palavra é mais semelhante em significado a "ENIGMA"?',
        optionA: 'Solução',
        optionB: 'Quebra-cabeça',
        optionC: 'Resposta',
        optionD: 'Declaração'
      },
      q16: {
        question: 'O que significa "SORRATEIRO"?',
        optionA: 'Aberto',
        optionB: 'Secreto',
        optionC: 'Barulhento',
        optionD: 'Claro'
      },
      q17: {
        question: 'Complete a analogia: ABSOLVER está para justificar assim como REPREENDER está para ____',
        optionA: 'Elogiar',
        optionB: 'Criticar',
        optionC: 'Ignorar',
        optionD: 'Apoiar'
      }
    },
    numerical: {
      q18: {
        question: 'Se um produto custa R$80 e tem desconto de 25%, qual é o novo preço?',
        optionA: 'R$55',
        optionB: 'R$60',
        optionC: 'R$65',
        optionD: 'R$70'
      },
      q19: {
        question: 'O que vem a seguir nesta sequência: 2, 6, 18, 54, ?',
        optionA: '108',
        optionB: '162',
        optionC: '216',
        optionD: '270'
      },
      q20: {
        question: 'Se 3x + 7 = 22, qual é o valor de x?',
        optionA: '3',
        optionB: '4',
        optionC: '5',
        optionD: '6'
      },
      q21: {
        question: 'Qual é o próximo número: 1, 4, 9, 16, 25, ?',
        optionA: '30',
        optionB: '32',
        optionC: '36',
        optionD: '40'
      },
      q22: {
        question: 'Se 40% de um número é 60, qual é o número?',
        optionA: '120',
        optionB: '140',
        optionC: '150',
        optionD: '160'
      },
      q23: {
        question: 'Quanto é 25% de 80 mais 30% de 60?',
        optionA: '35',
        optionB: '38',
        optionC: '41',
        optionD: '44'
      },
      q24: {
        question: 'Se y = 2x + 3 e x = 4, qual é o valor de y?',
        optionA: '9',
        optionB: '10',
        optionC: '11',
        optionD: '12'
      },
      q25: {
        question: 'Qual é o padrão: 2, 5, 11, 23, ?',
        optionA: '41',
        optionB: '45',
        optionC: '47',
        optionD: '51'
      },
      q26: {
        question: 'Se uma caixa contém 24 itens e você remove 1/3, quantos restam?',
        optionA: '14',
        optionB: '16',
        optionC: '18',
        optionD: '20'
      },
      q27: {
        question: 'Qual é o próximo número nesta sequência: 1, 8, 27, 64, ?',
        optionA: '100',
        optionB: '125',
        optionC: '144',
        optionD: '169'
      },
      q28: {
        question: 'Se 2x - 5 = 3x + 7, qual é o valor de x?',
        optionA: '-12',
        optionB: '-10',
        optionC: '-8',
        optionD: '-6'
      },
      q29: {
        question: 'Uma sequência segue a regra: cada termo é o dobro do anterior mais 1. Se o primeiro termo é 3, qual é o quarto termo?',
        optionA: '15',
        optionB: '21',
        optionC: '31',
        optionD: '35'
      },
      q30: {
        question: 'Qual porcentagem 45 representa de 180?',
        optionA: '20%',
        optionB: '25%',
        optionC: '30%',
        optionD: '35%'
      },
      q31: {
        question: 'Se a média de 5 números é 12, e 4 deles são 8, 10, 14 e 16, qual é o quinto número?',
        optionA: '10',
        optionB: '12',
        optionC: '14',
        optionD: '16'
      },
      q32: {
        question: 'Um carro percorre 240 km em 3 horas, depois 160 km em 2 horas. Qual é a velocidade média de toda a viagem?',
        optionA: '75 km/h',
        optionB: '80 km/h',
        optionC: '85 km/h',
        optionD: '90 km/h'
      },
      q33: {
        question: 'Se 3/4 de um número é igual a 2/3 de 90, qual é o número?',
        optionA: '72',
        optionB: '75',
        optionC: '80',
        optionD: '85'
      },
      q34: {
        question: 'Qual é o próximo termo na sequência: 3, 7, 15, 31, ?',
        optionA: '59',
        optionB: '63',
        optionC: '67',
        optionD: '71'
      }
    },
    abstract: {
      q35: {
        question: 'Complete o padrão: A1B2C3D4?',
        optionA: 'E5',
        optionB: 'F6',
        optionC: 'E4',
        optionD: 'D5'
      },
      q36: {
        question: 'Qual forma é a diferente: Círculo, Quadrado, Triângulo, Retângulo?',
        optionA: 'Círculo',
        optionB: 'Quadrado',
        optionC: 'Triângulo',
        optionD: 'Retângulo'
      },
      q37: {
        question: 'O que vem a seguir: 1, 1, 2, 3, 5, 8, ?',
        optionA: '11',
        optionB: '12',
        optionC: '13',
        optionD: '14'
      },
      q38: {
        question: 'Se ★ representa 4 e ♦ representa 7, quanto é ★ × ♦?',
        optionA: '24',
        optionB: '26',
        optionC: '28',
        optionD: '30'
      },
      q39: {
        question: 'Qual número completa o padrão: 2, 4, 8, 16, ?',
        optionA: '24',
        optionB: '28',
        optionC: '32',
        optionD: '36'
      },
      q40: {
        question: 'Qual padrão continua: XYZ, WXY, VWX, ?',
        optionA: 'UVW',
        optionB: 'VWX',
        optionC: 'TUV',
        optionD: 'UVX'
      },
      q41: {
        question: 'Complete a sequência: 100, 81, 64, 49, ?',
        optionA: '36',
        optionB: '35',
        optionC: '34',
        optionD: '33'
      },
      q42: {
        question: 'Qual vem a seguir: ◐◑◒◓?',
        optionA: '◐',
        optionB: '◑',
        optionC: '◒',
        optionD: '◓'
      },
      q43: {
        question: 'Se padrões se repetem a cada 3: ABCABCABC, qual é o 10º elemento?',
        optionA: 'A',
        optionB: 'B',
        optionC: 'C',
        optionD: 'D'
      },
      q44: {
        question: 'Complete: 1A, 3B, 5C, 7D, ?',
        optionA: '8E',
        optionB: '9E',
        optionC: '9F',
        optionD: '10E'
      },
      q45: {
        question: 'Qual elemento quebra o padrão: AEIOUA',
        optionA: 'A',
        optionB: 'E',
        optionC: 'I',
        optionD: 'U'
      },
      q46: {
        question: 'Qual é o próximo número em: 2, 6, 12, 20, 30, ?',
        optionA: '40',
        optionB: '42',
        optionC: '44',
        optionD: '46'
      },
      q47: {
        question: 'Complete a sequência lógica: Z1A, Y2B, X3C, ?',
        optionA: 'W4D',
        optionB: 'V4D',
        optionC: 'W5D',
        optionD: 'V5E'
      },
      q48: {
        question: 'Se símbolos seguem um padrão: ♠=1, ♥=4, ♦=9, ♣=16, quanto vale ★?',
        optionA: '20',
        optionB: '25',
        optionC: '30',
        optionD: '36'
      },
      q49: {
        question: 'O que vem a seguir no padrão matricial: [1,2][3,4], [2,3][4,5], [3,4][5,6], ?',
        optionA: '[4,5][6,7]',
        optionB: '[4,6][6,8]',
        optionC: '[5,6][7,8]',
        optionD: '[3,5][5,7]'
      },
      q50: {
        question: 'Complete a transformação: ABC→BCD, DEF→EFG, HIJ→?',
        optionA: 'IJK',
        optionB: 'JKL',
        optionC: 'HIK',
        optionD: 'HJK'
      }
    }
  }
};
